import Vue from 'vue'
import App from './App'
import router from './router'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)



const firebaseConfig = {
  apiKey: "AIzaSyAtM7Ln2wx-3M4XuyJZLYvHLCYsrTSbRgI",
  authDomain: "megawin-11838.firebaseapp.com",
  projectId: "megawin-11838",
  storageBucket: "megawin-11838.appspot.com",
  messagingSenderId: "304685944331",
  appId: "1:304685944331:web:87125dac253bea0295810e",
  measurementId: "G-RFL21D55J8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
window.gAnalytics = getAnalytics(app);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js